import { defineComponent as _defineComponent } from 'vue'
import {
  AbTitle,
  AbSection,
  AbContainer,
  AbDescription,
  AbSectionLayout,
} from '../../../ui';
import { DEFAULT_SPACING, Spacing } from '../../../../helpers/shared-props';
import { TextAlign } from '../../../../types';
import { computed } from 'vue-demi';

interface Props {
  id?: string;
  title?: string;
  description?: string;
  textAlign?: TextAlign;
  iframe: {
    src: string;
    width?: number;
    height?: number;
  };
  spacing?: Spacing;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionIframe',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: { default: 'center' },
    iframe: null,
    spacing: { default: () => DEFAULT_SPACING }
  },
  setup(__props: any) {

const props = __props as { id?: string, title?: string, description?: string, textAlign: TextAlign, iframe: {
    src: string;
    width?: number;
    height?: number;
  }, spacing: Spacing };

const WIDTH_CSS_VAR_NAME = '--feature-iframe-section-size-custom-width';
const HEIGHT_CSS_VAR_NAME = '--feature-iframe-section-size-custom-height';



const featureIframeSectionClass = computed(() => {
  return {
    'feature-iframe-section--manual': props.iframe.width || props.iframe.height,
  };
});

const featureIframeSectionStyle = computed(() => {
  type Styles = Record<
    typeof WIDTH_CSS_VAR_NAME | typeof HEIGHT_CSS_VAR_NAME,
    number
  >;
  const styles = {} as Styles;
  const { width, height } = props.iframe;

  width && (styles[WIDTH_CSS_VAR_NAME] = width);
  height && (styles[HEIGHT_CSS_VAR_NAME] = height);

  return styles;
});

return { __sfc: true,WIDTH_CSS_VAR_NAME, HEIGHT_CSS_VAR_NAME, props, featureIframeSectionClass, featureIframeSectionStyle, AbTitle, AbSection, AbContainer, AbDescription, AbSectionLayout }
}

})